import { useState } from 'react';
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { createSignedUrl } from '@lib/s3-helper';
import { handleError } from '@lib/sentry-help';
import Logo from './logo';
import HeaderMenu from './app-header-menu';
import UserButton from './user-name-button';
import classes from './app-header.module.css';

function AppHeader() {
  const [isLoadingHelp, setIsLoadingHelp] = useState(false);

  const openHelpDocument = async () => {
    if (isLoadingHelp) {
      return;
    }

    setIsLoadingHelp(true);
    try {
      const url = await createSignedUrl('help/help.pdf');
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      handleError(error, 'Error creating signed URL:');
    } finally {
      setIsLoadingHelp(false);
    }
  };

  return (
    <Group justify="space-between" align="center" className={classes.header}>
      <Group justify="flex-start" align="center" gap="md">
        <Logo />
        <HeaderMenu />
      </Group>
      <Group justify="flex-end" align="center" gap="xs">
        <UserButton />
        <Tooltip label="Help" position="bottom" withArrow>
          <ActionIcon
            variant="transparent"
            size="md"
            component="button"
            onClick={openHelpDocument}
            disabled={isLoadingHelp}
            aria-disabled={isLoadingHelp}
            aria-busy={isLoadingHelp}
            aria-label="Help"
          >
            <IconHelp className={classes.help} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
}

export default AppHeader;
